const fuelMapping = {
  Diesel: 'Diésel',
  Hybrid: 'Híbrido',
  LPG: 'Gas licuado',
  'Natural Gas': 'Gas natural',
  Petrol: 'Gasolina',
  'Petrol or gas': 'Gasolina o gas natural'
}

export default fuelMapping;



// WEBPACK FOOTER //
// ./src/constants/fuelMapping.js